<template>
  <VView class="prizes" back-button-to="/menu" :header="$t('prizes.header')">
    <VBlock max-width="955px">
      <img src="@/assets/prizes-poster.png" />
    </VBlock>

    <!-- <VBlock max-width="460px">
      <transition name="bounceUp" appear>
        <VButton to="/contest">Weź udział!</VButton>
      </transition>
    </VBlock> -->
  </VView>
</template>

<script>
export default {
  name: 'Prizes',
};
</script>

<style lang="scss" scoped>
.prizes {}
</style>
